export default __webpack_public_path__ + "8f172c6e0fc7f40ae60cceb004a82ea5.png";